import omitBy from 'lodash/omitBy'
import isNull from 'lodash/isNull'

// it tries open link in new window
// when it fails, it opens link in the same tab
export const openLinkNewTab = (href: string) => {
  const redirectWindow = window.open(href, '_blank')
  if (redirectWindow === null) {
    window.location.href = href
  }
}

export const getUtmParams = (url: URL) =>
  omitBy(
    {
      AgentID: url.searchParams.get('AgentID'),
      creative: url.searchParams.get('creative'),
      gemid1: url.searchParams.get('gemid1'),
      utm_campaign: url.searchParams.get('utm_campaign'),
      utm_content: url.searchParams.get('utm_content'),
      utm_medium: url.searchParams.get('utm_medium'),
      utm_source: url.searchParams.get('utm_source'),
      utm_term: url.searchParams.get('utm_term'),
    },
    isNull
  )

export const reloadPage = () => {
  window.location.href = window.location.href.lastIndexOf('#')
    ? window.location.href.substr(0, window.location.href.lastIndexOf('#'))
    : window.location.href
}
